import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, TemplateRef } from '@angular/core';
import { Sidebar } from './sidebar.service';

@Directive({ standalone: false, selector: '[flSidebarSubheading]' })
export class SidebarSubheadingDirective implements OnInit, OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private sidebar: Sidebar,
  ) {}

  ngOnInit(): void {
    this.sidebar.setSubHeading(this.templateRef);
  }

  ngOnDestroy(): void {
    this.sidebar.setSubHeading(undefined);
  }
}
